export const shopProductUnits = {
  'Analytical data': 'data sets',
  Review: 'reviews',
  Assessment: 'assessments',
  Rating: 'ratings',
  Research: 'publications',
  'Access to analysts': 'hours',
};
